import { Colors } from '../../consts/Colors';
import { tags } from '../../consts/Tags';

export default class Zone1 extends Phaser.GameObjects.Container {
    constructor(scene, zoneData) {
        super(scene, zoneData.zoneX, zoneData.zoneY, []);

        scene.add.existing(this);
        this.scene = scene;
        this.zoneId = zoneData.zoneId
        this.typeId = zoneData.typeId

        this.dropZone = this.scene.add.image(0, 0, zoneData.image).setOrigin(0.5);
        this.add(this.dropZone);
 
    }

    setActive() {
        this.dropZone.setTint(0xFFFFFF);
        this.setSize(this.dropZone.width, this.dropZone.height);
        this.setInteractive({ dropZone: true });
    }

    addDeck(deck) {
        this.deck = deck;
    }

    setGood() {

    }

    setWrong(cardImg) {
        this.isError = true;

        this.item.setTint(0xFFFFFF);
        this.item.setScale(1);
        this.item.setTexture(cardImg);
        this.itemStroke = this.scene.add.graphics();
        this.itemStroke.lineStyle(5, Colors.Elmt.Red, 1); // Définit l'épaisseur et la couleur de la bordure
        this.itemStroke.strokeRect(
            -this.item.displayWidth / 2,
            -this.item.displayHeight / 2,
            this.item.displayWidth,
            this.item.displayHeight
        );
        this.add(this.itemStroke);
        // this.itemStroke.setScale(0.9)
        this.itemStroke.setAlpha(0);
        this.scene.tweens.add({
            targets: this.itemStroke,
            alpha: 1,
            duration: 250,
            // ease: 'Linear',
            repeat: 2,
            yoyo: true,
            onComplete: () => {
                // this.item.setScale(0.5);
            }
        });
        this.disableInteractive();
    }

    onPointerOver() {
        this.dropZone.setTint(0x777777);
    }
    onPointerOut() {
        this.dropZone.setTint(0xFFFFFF);
    }
    dragOnPointerOver() {
        this.dropZone.setTint(0x777777);
    }
    dragOnPointerOut() {
        this.dropZone.setTint(0xFFFFFF);
    }

    

    
}